import Actions from '../../odata/actions';

const actions = new Actions('userTarget', 'userTargets');

export default actions;
